import { Box, HStack, Image, Text, useMediaQuery } from "@chakra-ui/react";
import BUP from "../../assets/logo/bup-wakil.png";
import Homepage from "../../assets/background/homepage.png";
import Pemda from "../../assets/logo/pemda-karangasem.png";
import BPD from "../../assets/logo/bank-bpd.png";
import Ipos from "../../assets/logo/ipos.png";
import React from "react";

export default function Section1() {
  const [mobile] = useMediaQuery("(max-width: 600px)");

  return (
    <Box bgImage={Homepage} width="full" bgSize="cover">
      <Box p={mobile ? "5" : "40"} color="white">
        <HStack hidden={!mobile} spacing="3" my="2" align="center">
          <img src={Pemda} alt="Logo Pemda Karangasem" width="20px" />
          <img src={BPD} alt="Logo Pemda Karangasem" width="40px" />
          <img src={Ipos} alt="Logo Pemda Karangasem" width="70px" />
          <Box display="flex" justifyContent="flex-end">
            <Image
              display="flex"
              justifyContent="flex-end"
              src={BUP}
              alt="Logo Pemda Karangasem"
              h="10"
            />
          </Box>
        </HStack>
        <Text fontWeight="400" fontSize={mobile ? "16" : "40"}>
          Selamat Datang Di
        </Text>
        <Text fontWeight="700" fontSize={mobile ? "20" : "48"}>
          Mineral Bukan Logam Batuan Karangasem
        </Text>
      </Box>
    </Box>
  );
}
